import React from 'react'

import styles from './../style/MiniBlock.module.scss'

import { Container } from 'react-bootstrap'

import GreenButton from './GreenButton'
import FeedbackForm from './FeedbackForm'

class TakzeMiniBlock extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show_feedback: false
    }
  }

  showFeedback = () => {
    this.setState({ show_feedback: true });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  render() {

    const { show_feedback } = this.state

    return (
      <section className={`${styles.section}`}>
        <Container>
          <div className={styles.content}>
            <div>
              <div>
                Для обсуждения индивидуальных заказов позвоните, и мы сделаем предварительный расчет стоимости дубового окна по телефону.
              </div>
              <GreenButton
                text={`Заказать деревянные окна`}
                width={197}
                className={styles.btn}
                action={() => this.showFeedback()}
              />
            </div>
            <div>
              <div>Также у нас вы можете <a href="/okna-iz-sosny">заказать окна из сосны</a> или <a href="/okna-iz-listvennicy">лиственницы</a>.</div>
            </div>
          </div>
        </Container>
        <FeedbackForm
          title={`Заказать деревянные окна`}
          text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
          btn={`Отправить`}
          data={[]}
          show={show_feedback}
          handleClose={() => this.closeFeedback()}
        />
      </section>
    )
  }
}

export default TakzeMiniBlock